// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dn14dHtqqFrVrqSDe744y"};